import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import {
  ILongTermContractModel,
  pharmacistActions,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import getLongTermContractLabels from '../../../../common/LongTermContractLabels/LongTermContractLabels';
import PharmacyInfoCard from '../../../../common/PharmacyInfoCard';
import ThemeConstants from '../../../../../theme/ThemeConstants';
import WithSkeleton from '../../../../common/WithSkeleton';
import StackedBox from '../../../../common/StackedBox';
import strings from '../../../../../localization';
import ServiceCard from '../../../ServiceCard';

import styles from './styles';

interface IRequestContractDetailsCard {
  event: {
    longTermShiftContract?: ILongTermContractModel;
    favorite?: boolean;
    logoImage: string;
    pharmacyName: string;
    startDate: string;
    softwareName: string;
  };
  successAction:string,
}

const RequestContractDetailsCard: FC<IRequestContractDetailsCard> = ({
  event,
  successAction,
}) => {
  const {
    longTermShiftContract,
    favorite,
    logoImage,
    pharmacyName,
    startDate,
    softwareName,
  } = event ?? {};
  const {
    startDate: contractStart,
    endDate: contractEnd,
    longTermShiftContractId,
  } = longTermShiftContract ?? {};

  const SkeletonTypography = WithSkeleton({ successAction, variant: 'text' })(
    Typography,
  );

  const { ShiftLabel } = getLongTermContractLabels({
    successAction,
    contractEndDate: contractEnd,
    contractStartDate: contractStart,
    isLongTerm: !!longTermShiftContractId,
  });

  return (
    <StackedBox
      showStacks
      backgroundColor={ThemeConstants.stackedChips.postedChip}
    >
      <ServiceCard
        customContainerStyle={{ mb: 0, pt: '10px', pr: '10px' }}
        eventType={PharmacistLegendVariant.workshift}
        content={(
          <Box sx={styles.cardContainer}>
            <ShiftLabel />
            <Box sx={{ display: 'flex', my: 1 }}>
              <PharmacyInfoCard
                favorite={!!favorite}
                successAction={successAction}
                logoImage={logoImage}
                title={pharmacyName}
                date={startDate}
                longTermAttributes={{
                  contractEnd,
                  contractStart,
                  longTermShiftContractId,
                }}
              />
            </Box>
          </Box>
        )}
        footer={(
          <Box sx={styles.footerContainer}>
            <SkeletonTypography sx={styles.footerLabel}>
              {strings.software}
            </SkeletonTypography>
            <SkeletonTypography sx={styles.footerValue}>
              {softwareName}
            </SkeletonTypography>
          </Box>
        )}
      />
    </StackedBox>
  );
};

export default RequestContractDetailsCard;
